import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
const SvgLucideMove = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 2v20m3-3-3 3-3-3M19 9l3 3-3 3M2 12h20M5 9l-3 3 3 3M9 5l3-3 3 3"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgLucideMove);
const Memo = memo(ForwardRef);
export default Memo;
